module.exports = __webpack_public_path__ + "img/e487098.png";